var map = {
	"./area-charts.yaml": "9cfc",
	"./bar-chart-grouped.yaml": "0b8f",
	"./bar-chart-stacked.yaml": "f949",
	"./bar-chart.yaml": "7d19",
	"./cell-grid.yaml": "dd34",
	"./control-panel.yaml": "cf2e",
	"./data-table.yaml": "9278",
	"./donut-chart.yaml": "6dbb",
	"./heatmap.yaml": "8066",
	"./histogram.yaml": "a076",
	"./line-charts.yaml": "acb7",
	"./markdown.yaml": "9372",
	"./scatter-plot.yaml": "8f1c",
	"./stats-bar.yaml": "2648",
	"./stats-box.yaml": "51cf",
	"./word-cloud.yaml": "2efe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e33c";